module.exports = __webpack_public_path__ + "img/icon_minus_24.6eb830f6.svg";